import {
  ActionIcon,
  Avatar,
  Button,
  Divider,
  Group,
  Stack,
} from '@mantine/core'
import { useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { themeCfg } from '../../theme/theme'
import AppLegacyIcon from '../common/AppLegacyIcon'
import { ReactComponent as ImageCircle } from '../../assets/imgs/user/personCircle.svg'
import css from './AppMenu.module.css'
import AppAvatar from '../common/AppAvatar'
import AppIcon from '../common/AppIcon'

interface CustomProps {
  mode: 'horizontal' | 'vertical'
}

const AppMenu = ({ mode = 'vertical' }: CustomProps) => {
  const { formatMessage: msg } = useIntl()
  const profile = useSelector((state) => state.profile?.resp)
  const userRole = profile?.role
  const navigate = useNavigate()

  const menu = [
    { icon: 'home', label: msg({ id: 'home' }), url: '/app/home' },
    {
      icon: 'center',
      label: msg({ id: 'centers' }),
      url: '/app/centers/own',
      activeUrl: '/app/centers',
    },
    // {icon: "cashregister", label: msg({id: "cashRegisters"}), url: '/app/cash-registers', activeUrl: '/app/cash-registers'},
    {
      icon: 'fuel',
      label: msg({ id: 'gas.stations' }),
      url: '/app/fuelstations/summary',
      activeUrl: '/app/fuelstations',
    },
    {
      icon: 'fuel-purchase',
      label: msg({ id: 'purchases' }),
      url: '/app/purchase/needs',
      activeUrl: '/app/purchase',
    },
    {
      icon: 'accounting-entry',
      label: msg({ id: 'accountingEntry.navbar' }),
      url: '/app/accounting-entry-g',
    },
    { icon: 'config', label: msg({ id: 'settings' }), url: '/app/settings' },
  ]

  const NavButtons = () =>
    menu.map((item, index) => (
      <Button
        bg="moure-blue"
        key={index}
        miw={30}
        h={mode === 'horizontal' ? '100%' : 40}
        w="100%"
        p={0}
        m={0}
        onClick={() => navigate(item?.url)}
        className={
          location.pathname.startsWith(item?.activeUrl) ||
          location.pathname.startsWith(item?.url)
            ? css.active
            : undefined
        }
        // bg={location.pathname === item?.url ? "moure-orange" : undefined}
      >
        <AppIcon icon={item?.icon} />
        {item?.label && mode === 'vertical' && (
          <Group ml="md">{item?.label}</Group>
        )}
      </Button>
    ))

  if (mode === 'horizontal')
    return (
      <Group
        bg="moure-blue"
        px={themeCfg?.default?.padding}
        h={30}
        className={css.horizontal}
        justify="space-around"
        wrap="nowrap"
        hiddenFrom={themeCfg?.breakpoint}
        miw={320}
      >
        <NavButtons />
      </Group>
    )
  return (
    <Stack w="100%" h="100%" className={css.vertical} bg="moure-blue" gap={0}>
      <Stack w="100%" gap={0}>
        <Group justify="center" pt="md" pb="xs">
          <AppAvatar />
        </Group>
        <Group gap={0}>
          <Group
            w="100%"
            h={30}
            c="white"
            className={css.title}
            justify="center"
            fz={14}
          >
            {profile?.name}
          </Group>
          <Group
            w="100%"
            h={18}
            c="white"
            className={css.text}
            justify="center"
            fz={12}
          >
            {userRole?.role}
          </Group>
        </Group>
      </Stack>

      <Divider
        orientation="horizontal"
        my="xs"
        size="xs"
        color="white"
        opacity={0.1}
      />

      <Group w="100%">
        <Stack w="100%" h="100%" pl="md" justify="flex-start" gap="xs">
          <NavButtons />
        </Stack>
      </Group>
    </Stack>
  )
}

export default AppMenu
